var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 427319320"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 0.5C8.96 0.5 0 9.46 0 20.5C0 31.54 8.96 40.5 20 40.5C31.04 40.5 40 31.54 40 20.5C40 9.46 31.04 0.5 20 0.5ZM20 32.5C18.5333 32.5 17.3333 31.3 17.3333 29.8333C17.3333 28.3667 18.5333 27.1667 20 27.1667C21.4667 27.1667 22.6667 28.3667 22.6667 29.8333C22.6667 31.3 21.4667 32.5 20 32.5ZM23.0533 11.82L22.16 22.5133C22.0667 23.6333 21.1333 24.5 20 24.5C18.8667 24.5 17.9333 23.6333 17.84 22.5133L16.9467 11.82C16.8 10.0333 18.2 8.5 20 8.5C21.7067 8.5 23.0667 9.88667 23.0667 11.5667C23.0667 11.6467 23.0667 11.74 23.0533 11.82Z",
    fill: "#E01507"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorPayment);
export default __webpack_public_path__ + "static/media/error-payment.df737255e358fdef6b70b5457a1e38a8.svg";
export { ForwardRef as ReactComponent };